/* Citrus Trio layout only: no price, cart, payment or tracking changes. */
(() => {
  'use strict';
  if (!document.body.classList.contains('dolce-cro-trio') || window.__dolceTrioLayout) return;
  window.__dolceTrioLayout = true;
  const productId = '8086481764430';
  const observed = new WeakSet();
  function enhance(root = document) {
    const form = root.querySelector(`.product-information product-form-component[data-product-id="${productId}"]`)
      || (root.matches?.('.product-information') ? root.querySelector(`product-form-component[data-product-id="${productId}"]`) : null);
    const details = form?.closest('.product-details');
    const buy = form?.closest('.buy-buttons-block');
    if (!details || !buy || !buy.parentElement || buy.parentElement.closest('form')) return;
    const price = details.querySelector(`product-price[data-product-id="${productId}"]`);
    const installments = price?.querySelector(':scope > .installments');
    // Move the existing complete installment widget, never clone or nest forms.
    if (installments) {
      const old = buy.parentElement.querySelector(':scope > .dolce-trio-installments');
      if (old && old !== installments) old.remove();
      installments.classList.add('dolce-trio-installments');
      buy.after(installments);
    }
    const note = price?.querySelector(':scope > .tax-note');
    if (note) note.hidden = !note.textContent.trim() && !note.children.length;
    const title = details.querySelector('.dolce-product-heading__title')?.textContent.trim();
    const sticky = document.querySelector(`sticky-add-to-cart[data-product-id="${productId}"] .sticky-add-to-cart__title`);
    if (sticky && title && sticky.textContent.trim() !== title) sticky.textContent = title;
    const section = details.closest('.product-information');
    if (!section || observed.has(section)) return;
    observed.add(section);
    let scheduled = false;
    const observer = new MutationObserver((changes) => {
      const relevant = changes.some((change) => [...change.addedNodes].some((node) =>
        node instanceof Element && (node.matches('product-price, .installments, .buy-buttons-block')
        || node.querySelector('product-price, .installments, .buy-buttons-block'))));
      if (!relevant || scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (!section.isConnected) { observer.disconnect(); return; }
        enhance(section);
      });
    });
    observer.observe(section, { childList: true, subtree: true });
  }
  function init() { enhance(); }
  init();
  document.addEventListener('shopify:section:load', init);
})();
